import React    from 'react';
import {Outlet} from "react-router-dom";

import imgBgAuthLeft       from "../../../assets/images/bg-auth-left.png";
import {Card, CardContent} from "@mui/material";
import imgLogo             from "../../../assets/images/VerifyOn-Logo.png";

function Index() {
    return (<div className="container-fluid d-flex justify-content-center align-items-center vh-100 bg-auth">
        <div className="row w-100 justify-content-center">
            <div className="col-lg-8 col-md-10">
                <Card className="auth-card">
                    <CardContent className="p-0">
                        <div className="row g-0">
                            <div className="col-md-7 d-none d-md-block">
                                <div className="auth-image-container">
                                    <img src={imgBgAuthLeft} alt="" className="img-fluid auth-left-image" />
                                </div>
                            </div>
                            <div className="col-md-5 d-flex align-items-center">
                                <div className="w-100 p-4">
                                    <div className="text-center mb-4">
                                        <img src={imgLogo} alt="logo" className="auth-logo"/>
                                    </div>
                                    <Outlet/>
                                </div>
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    </div>);
}

export default Index;
